import { formTypes } from '.';
import { documentTypesValueLabelList } from '../../catalogs/documentTypes';
import { iso3166CountrieslabelLabelList } from '../../catalogs/ISO3166Countries';
import { personTypesValueLabelList } from '../../catalogs/personTypes';

export const pseFields = {
  moviiBankCode: { key: 'moviiBankCode', label: 'Banco', placeholder: 'Bancolombia', type: formTypes.select, options: [] },
  name: { key: 'name', label: 'Nombre', placeholder: 'Juan Andrés' },

  identificationType: {
    key: 'identificationType',
    label: 'Tipo de identificación',
    type: formTypes.select,
    options: documentTypesValueLabelList,
    show: value => value.typeOfPerson !== '1'
  },
  identificationNumber: {
    key: 'identificationNumber',
    label: 'Número de identificación',
    type: formTypes.number,
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '30000000'
  },

  email: {
    key: 'email',
    label: 'Correo electrónico',
    validate: true,
    placeholder: 'correo@ejemplo.com'
  },
  address: { key: 'address', label: 'Dirección', placeholder: 'Calle 97 #72-107' },
  phone: {
    keyIndicative: 'phoneIndicative',
    key: 'phone',
    label: 'Teléfono celular',
    type: formTypes.phone,
    placeholder: '30000000'
  },
  country: { key: 'country', label: 'País', type: formTypes.select, options: iso3166CountrieslabelLabelList },
  typeOfPerson: {
    key: 'typeOfPerson',
    label: 'Naturaleza jurídica',
    type: formTypes.select,
    options: personTypesValueLabelList.filter(({ value }) => value === '2')
  }
};
